
import Vue from 'vue'
import { CIcon, CIconFactory, Icon, IconSize } from '@tokyojob/frontend-components'
interface IData {
  closeIcon: Icon
}
export default Vue.extend({
  components: {
    CIcon,
  },
  props: {
    error: {
      type: String,
      required: true,
    },
  },
  data(): IData {
    const closeIcon = CIconFactory.Icon({
      icon: 'circle-xmark',
      size: IconSize.large
    })
    return {
      closeIcon,
    }
  },
  methods: {
    /**
     * Signal parent to reset gpsError, closing the error message
     */
    closeError() {
      this.$emit('close')
    }
  }
})
